import w from "./objectWithoutPropertiesLoose.mjs";
import l from "./extends.mjs";
import * as d from "react";
import o from "./index180.mjs";
import { clsx as x } from "./clsx.mjs";
import { alpha as p } from "@mui/system";
import E, { rootShouldForwardProp as F } from "./styled.mjs";
import G from "./useThemeProps.mjs";
import $ from "./ListContext.mjs";
import i, { getMenuItemUtilityClass as L } from "./menuItemClasses.mjs";
import { jsx as I } from "react/jsx-runtime";
import _ from "./ButtonBase.mjs";
import O from "./listItemIconClasses.mjs";
import M from "./dividerClasses.mjs";
import N from "./listItemTextClasses.mjs";
import D from "./useEnhancedEffect.mjs";
import S from "./useForkRef.mjs";
import U from "./composeClasses.mjs";
const H = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], z = (e, t) => {
  const {
    ownerState: s
  } = e;
  return [t.root, s.dense && t.dense, s.divider && t.divider, !s.disableGutters && t.gutters];
}, W = (e) => {
  const {
    disabled: t,
    dense: s,
    divider: a,
    disableGutters: c,
    selected: u,
    classes: r
  } = e, n = U({
    root: ["root", s && "dense", t && "disabled", !c && "gutters", a && "divider", u && "selected"]
  }, L, r);
  return l({}, r, n);
}, q = E(_, {
  shouldForwardProp: (e) => F(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: z
})(({
  theme: e,
  ownerState: t
}) => l({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${i.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : p(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${i.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : p(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${i.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : p(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : p(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${i.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${i.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${M.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${M.inset}`]: {
    marginLeft: 52
  },
  [`& .${N.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${N.inset}`]: {
    paddingLeft: 36
  },
  [`& .${O.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && l({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${O.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), T = /* @__PURE__ */ d.forwardRef(function(t, s) {
  const a = G({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: c = !1,
    component: u = "li",
    dense: r = !1,
    divider: b = !1,
    disableGutters: n = !1,
    focusVisibleClassName: k,
    role: R = "menuitem",
    tabIndex: v,
    className: V
  } = a, B = w(a, H), g = d.useContext($), y = d.useMemo(() => ({
    dense: r || g.dense || !1,
    disableGutters: n
  }), [g.dense, r, n]), m = d.useRef(null);
  D(() => {
    c && (m.current ? m.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [c]);
  const P = l({}, a, {
    dense: y.dense,
    divider: b,
    disableGutters: n
  }), f = W(a), j = S(m, s);
  let C;
  return a.disabled || (C = v !== void 0 ? v : -1), /* @__PURE__ */ I($.Provider, {
    value: y,
    children: /* @__PURE__ */ I(q, l({
      ref: j,
      role: R,
      tabIndex: C,
      component: u,
      focusVisibleClassName: x(f.focusVisible, k),
      className: x(f.root, V)
    }, B, {
      ownerState: P,
      classes: f
    }))
  });
});
process.env.NODE_ENV !== "production" && (T.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: o.bool,
  /**
   * The content of the component.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: o.bool,
  /**
   * @ignore
   */
  disabled: o.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: o.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: o.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: o.string,
  /**
   * @ignore
   */
  role: o.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: o.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * @default 0
   */
  tabIndex: o.number
});
const ce = T;
export {
  ce as default,
  z as overridesResolver
};
//# sourceMappingURL=MenuItem.mjs.map
